import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { InvoiceEntity } from '../../../data/repositories/configuration/entities/invoice.entity';
import { InvoiceResponseEntity } from '../../../data/repositories/configuration/entities/invoice-response.entity';
import { ConfigurationRepository } from '../../repositories/configuration.repository';

export class InsertInvoiceUseCase implements UseCase<InvoiceEntity, InvoiceResponseEntity> {
    constructor(private config: ConfigurationRepository) { }
    execute(
        params: InvoiceEntity,
    ): Observable<InvoiceResponseEntity> {
        return this.config.insertInvoice(params);
    }
}
